









































































































































































































import { Vue, Component } from "vue-property-decorator";

@Component
export default class WhyGritifyCompany extends Vue {
  toggleOpen(v: any) {
    v.isOpen = !(v.isOpen ?? false);
  }

  async goToPath(path: string) {
    if (this.$route.hash) {
      await this.$router.replace(path.split("#")[0]!);
    }
    this.$router.replace(path);
  }

  question1Open = false;
  question2Open = false;
  question3Open = false;
  question4Open = false;
}
